// LeafLink's orders-received `status` filter takes these lowercase values, unlike the capitalized OrderResponse.status.
export const LEAFLINK_ORDER_FILTER_STATUSES = [
    'draft',
    'submitted',
    'accepted',
    'backorder',
    'fulfilled',
    'shipped',
    'complete',
    'rejected',
    'combined',
    'cancelled',
];
//# sourceMappingURL=leaflink-order-filter-statuses.js.map